/**
 * 开放平台后台：状态/类型中文文案（运维可读）
 */

export const ENTITY_TYPE_MAP = {
  dept: '部门',
  student: '学生',
  staff: '教师',
  studentParent: '监护人',
  device: '设备',
  accessRule: '门禁规则',
  accessSubRule: '门禁子规则'
};

export const OPERATION_MAP = {
  add: '新增',
  update: '修改',
  delete: '删除',
  notify: '下发通知'
};

export const LIFE_CYCLE_MAP = {
  Active: '有效',
  PendingDelete: '待删除',
  Deleted: '已删除'
};

export const SYNC_STATUS_MAP = {
  pending: '等待处理',
  blocked: '被拦住（缺依赖）',
  syncing: '同步中',
  succeeded: '成功',
  retryPending: '失败等再试',
  unknownOutcome: '结果不清楚',
  reconciling: '对账中',
  rejected: '天波侧失败被拒',
  superseded: '已被新任务替代',
  manualReview: '需要人工看着'
};

export const EVENT_TYPE_MAP = {
  doorRecord: '通行记录',
  doorDeviceStatus: '设备在线状态'
};

export const INBOX_STATUS_MAP = {
  Received: '已收到',
  Processed: '已处理',
  NoPartnerMapping: '找不到合作方',
  Failed: '处理失败'
};

export const OUTBOX_STATUS_MAP = {
  Pending: '待推送',
  Sending: '推送中',
  Succeeded: '已推成功',
  Dead: '多次失败已放弃'
};

export const ATTEMPT_OUTCOME_MAP = {
  Succeeded: '成功',
  Timeout: '超时',
  Rejected: '被天波拒绝',
  UnknownOutcome: '结果不清楚',
  Error: '出错'
};

/** 同步步骤英文名 → 运维可读中文 */
export const STEP_NAME_MAP = {
  upsertParent: '写入/更新天波家长',
  bindStudentParentRel: '绑定学生-家长关系',
  unbindStudentParentRel: '解绑学生-家长关系',
  delParent: '删除天波家长'
};

export function labelOf(map, value, fallback) {
  if (value === null || value === undefined || value === '') return fallback || '—';
  return map[value] || value;
}

export function entityTypeText(v) {
  return labelOf(ENTITY_TYPE_MAP, v);
}

export function operationText(v) {
  return labelOf(OPERATION_MAP, v);
}

export function syncStatusText(v) {
  return labelOf(SYNC_STATUS_MAP, v);
}

export function lifeCycleText(v) {
  return labelOf(LIFE_CYCLE_MAP, v);
}

export function eventTypeText(v) {
  return labelOf(EVENT_TYPE_MAP, v);
}

export function inboxStatusText(v) {
  return labelOf(INBOX_STATUS_MAP, v);
}

export function outboxStatusText(v) {
  return labelOf(OUTBOX_STATUS_MAP, v);
}

export function attemptOutcomeText(v) {
  return labelOf(ATTEMPT_OUTCOME_MAP, v);
}

export function stepNameText(v) {
  return labelOf(STEP_NAME_MAP, v);
}

/** 命令摘要 / JSON 美化 */
export function prettyJsonText(raw) {
  if (raw === null || raw === undefined || raw === '') return '—';
  const s = String(raw).trim();
  if (!s) return '—';
  try {
    return JSON.stringify(JSON.parse(s), null, 2);
  } catch (e) {
    return s;
  }
}

/** 访问日志摘要：code=0;msg=ok → 描述列表 */
export function parseKvSummary(raw) {
  const s = (raw || '').trim();
  if (!s) return [];
  if (s.startsWith('{') || s.startsWith('[')) {
    try {
      const obj = JSON.parse(s);
      if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
        return Object.keys(obj).map(k => ({ label: k, value: String(obj[k]) }));
      }
    } catch (e) { /* fallthrough */ }
  }
  return s.split(';').map(p => p.trim()).filter(Boolean).map(p => {
    const i = p.indexOf('=');
    if (i < 0) return { label: '内容', value: p };
    return { label: p.slice(0, i), value: p.slice(i + 1) };
  });
}

export function syncStatusClass(v) {
  if (v === 'succeeded') return 'is-ok';
  if (v === 'rejected' || v === 'manualReview' || v === 'Dead' || v === 'Failed') return 'is-bad';
  if (v === 'retryPending' || v === 'unknownOutcome' || v === 'blocked') return 'is-warn';
  return '';
}

export function statusClass(v) {
  if (v === 'succeeded' || v === 'Succeeded' || v === 'Processed') return 'is-ok';
  if (v === 'rejected' || v === 'Dead' || v === 'Failed' || v === 'NoPartnerMapping') return 'is-bad';
  if (v === 'retryPending' || v === 'Pending' || v === 'unknownOutcome') return 'is-warn';
  return '';
}

/** 失败原因展示：空则给运维可读提示 */
export function failReasonText(raw, fallback) {
  const t = (raw || '').trim();
  if (t) return t;
  return fallback || '暂无详细原因，可点详情查看步骤/尝试记录';
}
